import isApiError from "@insite/client-framework/Common/isApiError";
import {
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import {
    ImagesZip,
    ImagesZipParameter,
    ImagesZipResultModel,
} from "@tSurya/Services/ImagesZipService";
import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

type ImagesZipParameterParam = HasOnSuccess<BlobPart> & ImagesZipParameter & HasOnError;

type HandlerType = CustomApiHandler<ImagesZipParameterParam, BlobPart>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = (await ImagesZip(props.apiParameter)) as unknown as BlobPart;
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult) {
        const blob = new Blob([props.apiResult], { type: "application/zip" });
        const url = window.URL.createObjectURL(blob);       
        const filename = `${props.apiParameter.brandName} ${props.apiParameter.productName} images.zip`;
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(url);

        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];

const ImagesZipSur = createHandlerChainRunner(chain, "ImagesZipSur");
export default ImagesZipSur;
